<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditGestaoAcessoDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <GestaoAcessoDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import GestaoAcessoDataTable from "../../components/shared/datatables/GestaoAcessoDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/gestaoAcesso";
import CreateEditGestaoAcessoDialog from "../../components/shared/dialogs/CreateEditGestaoAcessoDialog";
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "../../api/core";

export default {
  name: "index",
  components: {CreateEditGestaoAcessoDialog, BaseView, GestaoAcessoDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [     
        {
          name: 'Descricao',
          column: 'titulo',
          type: 'text'
        },
        {
          name: 'Recurso',
          column: 'link',
          type: 'text'
        },
        {
          name: 'Visível',
          column: 'flgVisivel',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.FLG_PADRAO
          })
        },  
        {
          name: 'Perfil Acesso',
          column: 'nivelAcesso',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.NIVEL_ACESSO_USUARIO_TODOS
          })
        },                  
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        id: null,
        link: "",
        titulo: "",
        nivelAcesso: "",
        descNicelAcesso: "",
        niveisAcesso: [],
        idPai: null,
        tituloPai: null,
        ordem: null,
        url: "",
        icon: "",
        flgVisivel: "",
        descFlgVisivel: "",
      };
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Item Acesso. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    },  
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Item Acesso removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover o Item Acesso.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Menu.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });      
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>